import { type HolderInputProps } from '../../-model/props';
import { Loader } from '@nosinovacao/fe-icons';
import { Button, Captcha, If, Input, useI18n } from '@nosinovacao/nosid-mfe-common';

export function HolderInputLight({
  associationType,
  value,
  errors,
  inputId,
  loading,
  disabled,
  onValueChange,
  onSubmit,
  captchaChallenge,
  onCaptchaChange,
}: Readonly<HolderInputProps>) {
  const { t } = useI18n();
  return (
    <form
      className="flex size-full flex-col gap-6 max-tablet:pb-8"
      onSubmit={onSubmit}
      data-tid="form-holder-input"
    >
      <Input
        label={`Services.AddServices.HolderInput.Label.${associationType}`}
        id={inputId}
        errors={errors}
        value={value}
        skin="light"
        onChange={(ev) => onValueChange(ev.target.value)}
        data-tid="input-holder"
      />
      <If condition={captchaChallenge}>
        <Captcha onChange={onCaptchaChange} />
      </If>
      <Button
        className="mt-auto w-full tablet:w-fit"
        skin="light"
        disabled={disabled || loading}
        data-tid="button-submit-holder"
      >
        <If condition={loading} otherwise={t('Services.AddServices.HolderInput.Confirm')}>
          <Loader width={24} height={24} />
        </If>
      </Button>
    </form>
  );
}
